module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "FanarLogo.37ce6d3e.png" + "?" + Date.now();